const pt = {
  // ============================================================
  // COMMON — Partilhado em toda a aplicação
  // ============================================================
  common: {
    loading: 'A carregar...',
    error: 'Erro',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Criar',
    add: 'Adicionar',
    remove: 'Remover',
    close: 'Fechar',
    confirm: 'Confirmar',
    apply: 'Aplicar',
    reset: 'Repor',
    search: 'Pesquisar',
    filter: 'Filtrar',
    clear: 'Limpar',
    back: 'Voltar',
    next: 'Seguinte',
    previous: 'Anterior',
    submit: 'Submeter',
    update: 'Atualizar',
    refresh: 'Atualizar',
    export: 'Exportar',
    import: 'Importar',
    download: 'Transferir',
    upload: 'Carregar',
    print: 'Imprimir',
    copy: 'Copiar',
    yes: 'Sim',
    no: 'Não',
    ok: 'OK',
    done: 'Concluído',
    select: 'Selecionar',
    selectAll: 'Selecionar Tudo',
    deselectAll: 'Desselecionar Tudo',
    noResults: 'Nenhum resultado encontrado',
    noData: 'Sem dados disponíveis',
    required: 'Obrigatório',
    optional: 'Opcional',
    actions: 'Ações',
    details: 'Detalhes',
    overview: 'Visão Geral',
    summary: 'Resumo',
    total: 'Total',
    all: 'Todos',
    none: 'Nenhum',
    name: 'Nome',
    type: 'Tipo',
    status: 'Estado',
    date: 'Data',
    time: 'Hora',
    description: 'Descrição',
    notes: 'Notas',
    comments: 'Comentários',
    category: 'Categoria',
    priority: 'Prioridade',
    nation: 'Nação',
    country: 'País',
    email: 'E-mail',
    phone: 'Telefone',
    address: 'Morada',
    location: 'Localização',
    coordinates: 'Coordenadas',
    latitude: 'Latitude',
    longitude: 'Longitude',
    from: 'De',
    to: 'Para',
    createdAt: 'Criado',
    updatedAt: 'Atualizado',
    createdBy: 'Criado por',
    modifiedBy: 'Modificado por',
    active: 'Ativo',
    inactive: 'Inativo',
    enabled: 'Ativado',
    disabled: 'Desativado',
    showing: 'A mostrar',
    of: 'de',
    page: 'Página',
    perPage: 'por página',
    rows: 'linhas',
    items: 'itens',
    results: 'resultados',
    sortBy: 'Ordenar por',
    ascending: 'Ascendente',
    descending: 'Descendente',
    viewAll: 'Ver Tudo',
    viewDetails: 'Ver Detalhes',
    goBack: 'Voltar',
    learnMore: 'Saber Mais',
    seeMore: 'Ver Mais',
    showMore: 'Mostrar Mais',
    showLess: 'Mostrar Menos',
    expandAll: 'Expandir Tudo',
    collapseAll: 'Recolher Tudo',
    copied: 'Copiado!',
    saved: 'Guardado!',
    deleted: 'Eliminado!',
    updated: 'Atualizado!',
    created: 'Criado!',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',
    danger: 'Perigo',
    unknown: 'Desconhecido',
    notAvailable: 'N/D',
    never: 'Nunca',
    today: 'Hoje',
    yesterday: 'Ontem',
    tomorrow: 'Amanhã',
    now: 'Agora',
    ago: 'atrás',
    justNow: 'agora mesmo',
    minutesAgo: '{{count}}m atrás',
    hoursAgo: '{{count}}h atrás',
    daysAgo: '{{count}}d atrás',
    monthsAgo: '{{count}}m atrás',
    id: 'ID',
    version: 'Versão',
    language: 'Idioma',
    theme: 'Tema',
    darkMode: 'Modo Escuro',
    lightMode: 'Modo Claro',
    failedToLoad: 'Falha ao carregar dados',
    failedToSave: 'Falha ao guardar',
    failedToDelete: 'Falha ao eliminar',
    failedToUpdate: 'Falha ao atualizar',
    confirmDelete: 'Tem a certeza de que pretende eliminar isto?',
    confirmAction: 'Tem a certeza?',
    unsavedChanges: 'Tem alterações por guardar. Tem a certeza de que pretende sair?',
    pageNotFound: '404 - Página Não Encontrada',
    pageNotFoundDesc: 'A página que procura não existe.',
    backToDashboard: 'Voltar ao Painel',
    characters: 'caracteres',
    maxCharacters: 'Máximo de {{max}} caracteres',
    remaining: '{{count}} restantes',
    selected: '{{count}} selecionados',
    of_total: '{{count}} de {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Cabeçalho, barra lateral, menus
  // ============================================================
  nav: {
    dashboard: 'Painel',
    requests: 'Pedidos',
    transports: 'Transportes',
    myPatients: 'Os Meus Pacientes',
    statistics: 'Estatísticas',
    flow: 'Fluxo',
    resources: 'Resources',
    exercise: 'Exercício',
    administration: 'Administração',
    map: 'Mapa',
    info: 'Informação',
    users: 'Utilizadores',
    assets: 'Meios',
    hubs: 'Hubs',
    treatmentFacilities: 'Instalações de Tratamento',
    patientImport: 'Importação de Pacientes',
    assetTemplates: 'Modelos de Meios',
    dayTemplates: 'Modelos de Dia',
    announcementTicker: 'Barra de Anúncios',
    exerciseStatistics: 'Estatísticas do Exercício',
    settings: 'Definições',
    auditLog: 'Registo de Auditoria',
    exerciseControl: 'Controlo do Exercício',
    dataSync: 'Sincronização de Dados',
    documentation: 'Documentação',
    support: 'Suporte',
    about: 'Sobre',
    assetContracts: 'Asset Contracts',
    notifications: 'Notificações',
    schedules: 'Horários',
    capacityPlanning: 'Planeamento de Capacidade',
    transportPlanning: 'Planeamento de Transportes',
    transportBooking: 'Reserva de Transporte',
    flowDiagram: 'Diagrama de Fluxo',
    changePassword: 'Alterar Palavra-passe',
    missions: 'Missões',
    startPoints: 'Pontos de Partida',
    hospital: 'Hospital',
  },

  // ============================================================
  // AUTH — Autenticação, palavra-passe, sessão
  // ============================================================
  auth: {
    login: 'Iniciar Sessão',
    logout: 'Terminar Sessão',
    logoutNow: 'Terminar Sessão Agora',
    loggingIn: 'A iniciar sessão...',
    loginFailed: 'Falha na autenticação',
    email: 'E-mail',
    password: 'Palavra-passe',
    username: 'Nome de utilizador',
    enterEmail: 'Introduza o seu endereço de e-mail',
    enterPassword: 'Introduza a sua palavra-passe',
    enterUsername: 'Introduza o seu nome de utilizador',
    forgotPassword: 'Esqueceu a palavra-passe?',
    forgotPasswordTitle: 'Recuperar Palavra-passe',
    forgotPasswordDesc: 'Introduza o seu nome de utilizador e endereço de e-mail. Se ambos corresponderem, os administradores serão notificados para repor a sua palavra-passe.',
    requestPasswordReset: 'Solicitar Reposição de Palavra-passe',
    sending: 'A enviar...',
    backToLogin: 'Voltar ao Início de Sessão',
    pleaseWait: 'Por favor, aguarde antes de tentar novamente.',
    requestFailed: 'Pedido falhado',
    credentialsMatch: 'Se as credenciais corresponderem, os administradores foram notificados.',
    forAccess: 'Para acesso, contacte o administrador do sistema.',
    changePassword: 'Alterar Palavra-passe',
    currentPassword: 'Palavra-passe Atual',
    newPassword: 'Nova Palavra-passe',
    confirmPassword: 'Confirmar Palavra-passe',
    passwordChanged: 'Palavra-passe alterada com sucesso',
    passwordMismatch: 'As palavras-passe não coincidem',
    passwordTooShort: 'A palavra-passe deve ter pelo menos 8 caracteres',
    changingPassword: 'A alterar...',
    mustChangePassword: 'Deve alterar a sua palavra-passe antes de continuar.',
    sessionExpiring: 'Sessão a Expirar',
    sessionExpireText: 'A sua sessão expira em <strong>{{time}}</strong>. Por favor, guarde o seu trabalho e inicie sessão novamente para continuar.',
    dismiss: 'Dispensar',
    switchNation: 'Mudar de Nação',
    returnTo: 'Voltar a {{nation}}',
    viewingAs: 'Está a visualizar como',
    loggedInAs: 'sessão iniciada como {{nation}}',
    trainingMode: 'APENAS PARA FINS DE TREINO',
    dedication: 'Criado com amor e dedicação à profissão',
  },

  // ============================================================
  // ROLES — Funções de utilizador e rótulos
  // ============================================================
  roles: {
    admin: 'Administrador do Sistema',
    excon: 'Controlador do Exercício',
    eu: 'Coordenador UE',
    planner: 'Planeador',
    hub: 'Gestor de Hub',
    nation: 'Nação',
    readOnly: 'Apenas Leitura',
    systemAdmin: 'Administrador do Sistema',
    transportPlanner: 'Planeador de Transportes',
    systemRoles: 'Funções do Sistema',
  },

  // ============================================================
  // STATUS — Estados de pedidos, ofertas, missões
  // ============================================================
  status: {
    draft: 'Rascunho',
    underReview: 'Em Revisão',
    published: 'Publicado',
    underSelection: 'Em Seleção',
    accepted: 'Aceite',
    planned: 'Planeado',
    inTransit: 'Em Trânsito',
    completed: 'Concluído',
    closed: 'Encerrado',
    withdrawn: 'Retirado',
    pending: 'Pendente',
    rejected: 'Rejeitado',
    cancelled: 'Cancelado',
    active: 'Ativo',
    inactive: 'Inativo',
    review: 'Revisão',
    selection: 'Seleção',
    transit: 'Trânsito',
  },

  // ============================================================
  // CATEGORIES — Categorias de pedidos
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Pessoal',
    material: 'Material',
    equipment: 'Equipamento',
    other: 'Outro',
    news: 'Notícias',
  },

  // ============================================================
  // URGENCY — Níveis de urgência
  // ============================================================
  urgency: {
    routine: 'Rotina',
    priority: 'Prioritário',
    urgent: 'Urgente',
    immediate: 'Imediato',
  },

  // ============================================================
  // ASSETS — Tipos de meios de transporte
  // ============================================================
  assetTypes: {
    train: 'Comboio',
    ship: 'Navio',
    aircraft: 'Aeronave',
    bus: 'Autocarro',
    ambulance: 'Ambulância',
    drone: 'Drone',
    helicopter: 'Helicóptero',
    ferry: 'Ferry',
    other: 'Outro',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Painel',
    goodMorning: 'Bom dia',
    goodAfternoon: 'Boa tarde',
    goodEvening: 'Boa noite',
    lastLogin: 'Último acesso',
    infrastructure: 'Infraestrutura',
    transportAssets: 'Meios de Transporte',
    treatmentFacilities: 'Instalações de Tratamento',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Estatísticas de Pedidos',
    viewAllRequests: 'Ver todos os pedidos',
    availableAssets: 'Meios Disponíveis',
    seated: 'Sentado',
    lying: 'Deitado',
    intensive: 'Intensivo',
    notifications: 'Notificações',
    markAllRead: 'Marcar todas como lidas',
    noNotifications: 'Ainda sem notificações',
    notifiedWhenActivity: 'Será notificado quando houver nova atividade',
    viewDetailsBtn: 'Ver Detalhes',
    nationUsers: 'Utilizadores da Nação',
    user: 'Utilizador',
    roles: 'Funções',
    noUsersFound: 'Nenhum utilizador encontrado',
    participatingNations: 'Nações Participantes',
    exerciseDisclaimer: 'Este sistema destina-se exclusivamente a exercícios. Introduza apenas dados simulados do exercício. Os fluxos de trabalho estão adaptados ao cenário do exercício e podem diferir dos procedimentos reais. As regras de segurança informática e proteção de dados permanecem plenamente aplicáveis.',
    notConfigured: 'Não configurado',
    requestCount: '{{count}} pedido(s)',
    clickToView: 'Clique para ver',
    systemAdministration: 'Administração do Sistema',
    exerciseControlTitle: 'Controlo do Exercício',
    euCoordination: 'Coordenação UE',
    transportPlanningTitle: 'Planeamento de Transportes',
    hubManagement: 'Gestão de Hubs',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Novo Pedido',
    myDrafts: 'Os Meus Rascunhos',
    pendingReview: 'Revisão Pendente',
    activeTransports: 'Transportes Ativos',
    myPatients: 'Os Meus Pacientes',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Pedidos',
    newRequest: 'Novo Pedido',
    createRequest: 'Criar Pedido',
    editRequest: 'Editar Pedido',
    requestDetail: 'Detalhe do Pedido',
    requestId: 'ID do Pedido',
    fromNation: 'Da Nação',
    toNation: 'Para a Nação',
    requestingNation: 'Nação Requerente',
    receivingNation: 'Nação Recetora',
    category: 'Categoria',
    urgency: 'Urgência',
    status: 'Estado',
    patients: 'Pacientes',
    patientCount: 'Número de Pacientes',
    offers: 'Ofertas',
    offerCount: 'Número de Ofertas',
    created: 'Criado',
    updated: 'Atualizado',
    submittedBy: 'Submetido por',
    reviewedBy: 'Revisto por',
    description: 'Descrição',
    medicalDetails: 'Detalhes Médicos',
    transportDetails: 'Detalhes de Transporte',
    additionalInfo: 'Informação Adicional',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Ponto de Partida',
    arrivalPoint: 'Ponto de Chegada',
    estimatedDeparture: 'Partida Estimada',
    estimatedArrival: 'Chegada Estimada',
    submitForReview: 'Submeter para Revisão',
    publish: 'Publicar',
    startSelection: 'Iniciar Seleção',
    acceptOffer: 'Aceitar Oferta',
    markInTransit: 'Marcar Em Trânsito',
    markCompleted: 'Marcar Concluído',
    closeRequest: 'Encerrar Pedido',
    withdrawRequest: 'Retirar Pedido',
    withdraw: 'Retirar',
    revertToDraft: 'Reverter para Rascunho',
    deleteRequest: 'Eliminar Pedido',
    duplicateRequest: 'Duplicar Pedido',
    createFollowUp: 'Criar Pedido Consolidado',
    followUpRequest: 'Pedido Consolidado',
    parentRequest: 'Pedido Original',
    childRequests: 'Pedidos Consolidados',
    noRequests: 'Nenhum pedido encontrado',
    noOffers: 'Ainda sem ofertas',
    addPatient: 'Adicionar Paciente',
    removePatient: 'Remover Paciente',
    patientDetails: 'Detalhes do Paciente',
    contactPerson: 'Pessoa de Contacto',
    contactPhone: 'Telefone de Contacto',
    contactEmail: 'E-mail de Contacto',
    specialRequirements: 'Requisitos Especiais',
    medicalEquipment: 'Equipamento Médico',
    accompaniment: 'Acompanhamento',
    timeline: 'Cronologia',
    history: 'Histórico',
    addComment: 'Adicionar Comentário',
    writeComment: 'Escreva um comentário...',
    postComment: 'Publicar Comentário',
    posting: 'A publicar...',
    noComments: 'Ainda sem comentários',
    coverageBar: 'Cobertura',
    covered: 'coberto',
    uncovered: 'descoberto',
    filterByStatus: 'Filtrar por estado',
    filterByCategory: 'Filtrar por categoria',
    filterByNation: 'Filtrar por nação',
    searchRequests: 'Pesquisar pedidos...',
    confirmWithdraw: 'Tem a certeza de que pretende retirar este pedido?',
    confirmDelete: 'Tem a certeza de que pretende eliminar este pedido?',
    confirmPublish: 'Tem a certeza de que pretende publicar este pedido? Ficará visível para todas as nações.',
    confirmStartSelection: 'Tem a certeza de que pretende iniciar a seleção? As nações poderão fazer ofertas.',
    warningStartSelection: 'Iniciar a seleção tornará este pedido visível para todas as nações participantes. Estas poderão submeter ofertas para os pacientes deste pedido. Esta ação não pode ser revertida.',
    warningMakeOffer: 'Ao submeter esta oferta, compromete a sua nação a prestar a assistência proposta. Esta ação notificará a nação requerente e o controlo do exercício.',
    saveDraft: 'Guardar Rascunho',
    saving: 'A guardar...',
    saveAndSubmit: 'Guardar e Submeter',
    step: 'Passo {{number}}',
    generalInfo: 'Informação Geral',
    patientInfo: 'Informação do Paciente',
    logisticsInfo: 'Informação Logística',
    reviewSubmit: 'Rever e Submeter',
    requestTitle: 'Título do Pedido',
    requestDescription: 'Descrição do Pedido',
    numberOfPatients: 'Número de Pacientes',
    typeOfAssistance: 'Tipo de Assistência',
    medicalTreatment: 'Tratamento Médico',
    transportAssistance: 'Assistência de Transporte',
    both: 'Ambos',
    treatmentOnly: 'Apenas Tratamento',
    transportOnly: 'Apenas Transporte',
    validationErrors: 'Por favor, corrija os seguintes erros:',
    fieldRequired: 'Este campo é obrigatório',
    selectExitHub: 'Selecione um hub de saída',
    createExitHub: 'Criar Hub de Saída',
    backToRequests: 'Voltar aos Pedidos',
    noRequestsFound: 'Nenhum pedido encontrado',
    createFirstRequest: 'Crie o seu primeiro pedido para começar',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Ofertas',
    createOffer: 'Criar Oferta',
    makeOffer: 'Fazer Oferta',
    manageOffers: 'Gerir Ofertas',
    offerDetail: 'Detalhe da Oferta',
    offerId: 'ID da Oferta',
    offeringNation: 'Nação Ofertante',
    offerType: 'Tipo de Oferta',
    treatment: 'Tratamento',
    transport: 'Transporte',
    combined: 'Combinado',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Oferta de Tratamento',
    transportOffer: 'Oferta de Transporte',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Selecionar Pacientes',
    selectedPatients: 'Pacientes Selecionados',
    patientSelection: 'Seleção de Pacientes',
    offerConfiguration: 'Configuração da Oferta',
    reviewOffer: 'Rever Oferta',
    submitOffer: 'Submeter Oferta',
    submitting: 'A submeter...',
    acceptOffer: 'Aceitar Oferta',
    rejectOffer: 'Rejeitar Oferta',
    withdrawOffer: 'Retirar Oferta',
    noOffers: 'Sem ofertas disponíveis',
    noOffer: 'No Offer',
    offerStatus: 'Estado da Oferta',
    offerDate: 'Data da Oferta',
    transportAsset: 'Meio de Transporte',
    departureDate: 'Data de Partida',
    arrivalDate: 'Data de Chegada',
    treatmentFacility: 'Instalação de Tratamento',
    capacity: 'Capacidade',
    availableCapacity: 'Capacidade Disponível',
    totalCapacity: 'Capacidade Total',
    selectAsset: 'Selecionar Meio',
    selectFacility: 'Selecionar Instalação',
    offerNotes: 'Notas da Oferta',
    confirmAccept: 'Tem a certeza de que pretende aceitar esta oferta?',
    confirmReject: 'Tem a certeza de que pretende rejeitar esta oferta?',
    extendTransport: 'Prolongar Transporte',
    transportExtension: 'Prolongamento de Transporte',
    comparisonView: 'Vista Comparativa',
    shortlist: 'Lista Restrita',
    addToShortlist: 'Adicionar à Lista Restrita',
    removeFromShortlist: 'Remover da Lista Restrita',
    leaveConfirmTitle: 'Sair desta página?',
    leaveConfirmMessage: 'Tem alterações por guardar. Tem a certeza de que pretende sair?',
    stayOnPage: 'Permanecer na Página',
    leavePage: 'Sair da Página',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transportes',
    missionDetail: 'Detalhe do Transporte',
    missionId: 'ID do Transporte',
    missionStatus: 'Estado do Transporte',
    createMission: 'Criar Transporte',
    overview: 'Visão Geral',
    patientsTab: 'Pacientes',
    transportsTab: 'Etapas de Transporte',
    treatmentTab: 'Tratamento',
    reviewTab: 'Revisão',
    departure: 'Partida',
    arrival: 'Chegada',
    origin: 'Origem',
    destination: 'Destino',
    stops: 'Paragens',
    addStop: 'Adicionar Paragem',
    removeStop: 'Remover Paragem',
    stopName: 'Nome da Paragem',
    stopType: 'Tipo de Paragem',
    estimatedTime: 'Hora Estimada',
    actualTime: 'Hora Real',
    asset: 'Meio',
    driver: 'Condutor',
    crew: 'Tripulação',
    noMissions: 'Nenhum transporte encontrado',
    completeMission: 'Concluir Transporte',
    cancelMission: 'Cancelar Transporte',
    startTransport: 'Iniciar Transporte',
    missionChain: 'Cadeia de Transporte',
    linkedMissions: 'Transportes Ligados',
    handover: 'Transferência',
    handoverPoint: 'Ponto de Transferência',
    pickupPoint: 'Ponto de Recolha',
    dropoffPoint: 'Ponto de Entrega',
    searchTransports: 'Pesquisar transportes...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacientes',
    myPatients: 'Os Meus Pacientes',
    patientId: 'ID do Paciente',
    firstName: 'Nome Próprio',
    lastName: 'Apelido',
    dateOfBirth: 'Data de Nascimento',
    age: 'Idade',
    gender: 'Género',
    male: 'Masculino',
    female: 'Feminino',
    other: 'Outro',
    nationality: 'Nacionalidade',
    diagnosis: 'Diagnóstico',
    condition: 'Condição',
    stable: 'Estável',
    critical: 'Crítico',
    serious: 'Grave',
    treatmentNeeded: 'Tratamento Necessário',
    allergies: 'Alergias',
    medications: 'Medicação',
    bloodType: 'Grupo Sanguíneo',
    weight: 'Peso (kg)',
    infectious: 'Infecioso',
    mentalHealth: 'Saúde Mental',
    mobility: 'Mobilidade',
    ambulatory: 'Ambulatório',
    wheelchair: 'Cadeira de Rodas',
    stretcher: 'Maca',
    intensive: 'Cuidados Intensivos',
    oxygenRequired: 'Oxigénio Necessário',
    ventilator: 'Ventilador',
    medicalEscort: 'Escolta Médica',
    noPatients: 'Nenhum paciente encontrado',
    patientDetails: 'Detalhes do Paciente',
    medicalHistory: 'Historial Médico',
    travelDocuments: 'Documentos de Viagem',
    passport: 'Passaporte',
    pseudonymizedId: 'ID Pseudonimizado',
    sensitiveData: 'Dados Sensíveis',
    journey: 'Percurso do Paciente',
    assignedTo: 'Atribuído a',
    currentLocation: 'Localização Atual',
    importPatients: 'Importar Pacientes',
    exportPatients: 'Exportar Pacientes',
    seated: 'Sentado',
    lying: 'Deitado',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Utilizadores',
    createUser: 'Criar Utilizador',
    editUser: 'Editar Utilizador',
    deleteUser: 'Eliminar Utilizador',
    username: 'Nome de Utilizador',
    displayName: 'Nome de Apresentação',
    email: 'E-mail',
    password: 'Palavra-passe',
    role: 'Função',
    roles: 'Funções',
    nation: 'Nação',
    active: 'Ativo',
    lastLogin: 'Último Acesso',
    createdAt: 'Criado',
    isNation: 'Nação',
    isEU: 'UE',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planeador',
    isHub: 'Hub',
    isReadOnly: 'Apenas Leitura',
    noUsers: 'Nenhum utilizador encontrado',
    confirmDelete: 'Tem a certeza de que pretende eliminar este utilizador?',
    resetPassword: 'Repor Palavra-passe',
    generatePassword: 'Gerar Palavra-passe',
    searchUsers: 'Pesquisar utilizadores...',
    userCreated: 'Utilizador criado com sucesso',
    userUpdated: 'Utilizador atualizado com sucesso',
    userDeleted: 'Utilizador eliminado com sucesso',
    selectNation: 'Selecione uma nação',
    mustChangePassword: 'Deve alterar a palavra-passe no próximo início de sessão',
    flagImage: 'Imagem da Bandeira',
    exportUsers: 'Exportar Utilizadores',
    importUsers: 'Importar Utilizadores',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Meios',
    createAsset: 'Criar Meio',
    editAsset: 'Editar Meio',
    deleteAsset: 'Eliminar Meio',
    assetName: 'Nome do Meio',
    assetType: 'Tipo de Meio',
    capacitySeated: 'Capacidade (Sentado)',
    capacityLying: 'Capacidade (Deitado)',
    capacityIntensive: 'Capacidade (Intensivo)',
    owner: 'Proprietário',
    operator: 'Operador',
    baseLocation: 'Localização Base',
    range: 'Alcance',
    speed: 'Velocidade',
    noAssets: 'Nenhum meio encontrado',
    confirmDelete: 'Tem a certeza de que pretende eliminar este meio?',
    searchAssets: 'Pesquisar meios...',
    assetCreated: 'Meio criado com sucesso',
    assetUpdated: 'Meio atualizado com sucesso',
    assetDeleted: 'Meio eliminado com sucesso',
    exportAssets: 'Exportar Meios',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Hubs',
    startPoints: 'Pontos de Partida',
    createHub: 'Criar Hub',
    editHub: 'Editar Hub',
    deleteHub: 'Eliminar Hub',
    hubName: 'Nome do Hub',
    hubType: 'Tipo de Hub',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Hub de Entrada',
    airport: 'Aeroporto',
    seaport: 'Porto Marítimo',
    railStation: 'Estação Ferroviária',
    roadPoint: 'Ponto Rodoviário',
    ucpmClassification: 'Classificação UCPM',
    icaoCode: 'Código ICAO',
    iataCode: 'Código IATA',
    noHubs: 'Nenhum hub encontrado',
    confirmDelete: 'Tem a certeza de que pretende eliminar este hub?',
    searchHubs: 'Pesquisar hubs...',
    nationAssignment: 'Atribuição de Nações',
    assignNations: 'Atribuir Nações',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Instalações de Tratamento',
    createFacility: 'Criar Instalação',
    editFacility: 'Editar Instalação',
    deleteFacility: 'Eliminar Instalação',
    facilityName: 'Nome da Instalação',
    facilityType: 'Tipo de Instalação',
    hospitalName: 'Nome do Hospital',
    bedCapacity: 'Capacidade de Camas',
    specialties: 'Especialidades',
    availableBeds: 'Camas Disponíveis',
    totalBeds: 'Total de Camas',
    contactPerson: 'Pessoa de Contacto',
    noFacilities: 'Nenhuma instalação de tratamento encontrada',
    confirmDelete: 'Tem a certeza de que pretende eliminar esta instalação?',
    searchFacilities: 'Pesquisar instalações...',
    hubNationAssignment: 'Atribuição de Hub a Nação',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Horários',
    createSchedule: 'Criar Horário',
    editSchedule: 'Editar Horário',
    deleteSchedule: 'Eliminar Horário',
    scheduleName: 'Nome do Horário',
    scheduleType: 'Tipo de Horário',
    recurring: 'Recorrente',
    oneTime: 'Pontual',
    frequency: 'Frequência',
    daily: 'Diário',
    weekly: 'Semanal',
    startDate: 'Data de Início',
    endDate: 'Data de Fim',
    departureTime: 'Hora de Partida',
    arrivalTime: 'Hora de Chegada',
    stops: 'Paragens',
    addStop: 'Adicionar Paragem',
    noSchedules: 'Nenhum horário encontrado',
    bookings: 'Reservas',
    timeline: 'Cronologia',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notificações',
    markAllRead: 'Marcar todas como lidas',
    markAsRead: 'Marcar como lida',
    markAsUnread: 'Marcar como não lida',
    noNotifications: 'Sem notificações',
    viewAll: 'Ver Todas as Notificações',
    settings: 'Definições de Notificações',
    emailNotifications: 'Notificações por E-mail',
    inAppNotifications: 'Notificações na Aplicação',
    notifyOn: 'Notificar-me sobre',
    requestCreated: 'Novo Pedido',
    requestPublished: 'Pedido Publicado',
    requestClosed: 'Pedido Encerrado',
    requestCompleted: 'Pedido Concluído',
    commentAdded: 'Novo Comentário',
    offerReceived: 'Oferta Recebida',
    offerAccepted: 'Oferta Aceite',
    statusChanged: 'Estado Alterado',
    selectionStarted: 'Seleção Iniciada',
    missionCreated: 'Transporte Criado',
    missionStatusUpdated: 'Transporte Atualizado',
    transportPartnerNamed: 'Parceiro de Transporte',
    transportExtensionReceived: 'Prolongamento de Transporte',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Definições',
    general: 'Geral',
    system: 'Sistema',
    email: 'E-mail',
    sync: 'Sincronização',
    security: 'Segurança',
    appearance: 'Aparência',
    systemName: 'Nome do Sistema',
    systemEmail: 'E-mail do Sistema',
    maintenanceMode: 'Modo de Manutenção',
    readOnlyMode: 'Modo Apenas Leitura',
    emailEnabled: 'E-mail Ativado',
    smtpHost: 'Servidor SMTP',
    smtpPort: 'Porta SMTP',
    smtpUser: 'Utilizador SMTP',
    smtpPassword: 'Palavra-passe SMTP',
    senderEmail: 'E-mail do Remetente',
    senderName: 'Nome do Remetente',
    testEmail: 'Enviar E-mail de Teste',
    syncEnabled: 'Sincronização Ativada',
    syncUrl: 'URL de Sincronização',
    syncApiKey: 'Chave API de Sincronização',
    settingsSaved: 'Definições guardadas com sucesso',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Título do Helpdesk',
    helpdeskEmail: 'E-mail do Helpdesk',
    helpdeskPhone: 'Telefone do Helpdesk',
    helpdeskInfo: 'Informação do Helpdesk',
    realLifeSupport: 'Apoio em Situação Real',
    trainingMode: 'Modo de Treino',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Registos de Auditoria',
    action: 'Ação',
    user: 'Utilizador',
    target: 'Alvo',
    details: 'Detalhes',
    timestamp: 'Data/Hora',
    ipAddress: 'Endereço IP',
    noLogs: 'Nenhum registo de auditoria encontrado',
    searchLogs: 'Pesquisar registos...',
    filterByAction: 'Filtrar por ação',
    filterByUser: 'Filtrar por utilizador',
    exportLogs: 'Exportar Registos',
    exportCsv: 'Exportar CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Controlo do Exercício',
    currentDay: 'Dia Atual',
    exerciseDay: 'Dia do Exercício',
    nextDay: 'Dia Seguinte',
    previousDay: 'Dia Anterior',
    resetExercise: 'Repor Exercício',
    startExercise: 'Iniciar Exercício',
    endExercise: 'Terminar Exercício',
    dayReset: 'Reposição do Dia',
    confirmReset: 'Tem a certeza de que pretende repor o dia do exercício? Isto eliminará todos os dados do dia atual.',
    resetInProgress: 'Reposição em curso...',
    maintenanceMode: 'Modo de Manutenção',
    enableMaintenance: 'Ativar Manutenção',
    disableMaintenance: 'Desativar Manutenção',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sincronização de Dados',
    syncStatus: 'Estado da Sincronização',
    lastSync: 'Última Sincronização',
    pendingItems: 'Itens Pendentes',
    syncNow: 'Sincronizar Agora',
    syncing: 'A sincronizar...',
    syncSuccess: 'Sincronização concluída com sucesso',
    syncFailed: 'Sincronização falhada',
    outbox: 'Caixa de Saída',
    inbox: 'Caixa de Entrada',
    configuration: 'Configuração',
    targetUrl: 'URL de Destino',
    apiKey: 'Chave API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Mapa',
    layers: 'Camadas',
    requests: 'Pedidos',
    hubs: 'Hubs',
    facilities: 'Instalações',
    routes: 'Rotas',
    showAll: 'Mostrar Tudo',
    hideAll: 'Ocultar Tudo',
    zoomIn: 'Aproximar',
    zoomOut: 'Afastar',
    resetView: 'Repor Vista',
    satellite: 'Satélite',
    terrain: 'Terreno',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Os mosaicos do mapa são servidos localmente',
    tilesOnline: 'Os mosaicos do mapa são carregados de servidores online',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Estatísticas',
    overview: 'Visão Geral',
    requestsByStatus: 'Pedidos por Estado',
    requestsByCategory: 'Pedidos por Categoria',
    requestsByNation: 'Pedidos por Nação',
    offersByStatus: 'Ofertas por Estado',
    patientsByCondition: 'Pacientes por Condição',
    transportsByStatus: 'Transportes por Estado',
    timeline: 'Cronologia',
    totalRequests: 'Total de Pedidos',
    totalOffers: 'Total de Ofertas',
    totalPatients: 'Total de Pacientes',
    totalTransports: 'Total de Transportes',
    averageResponseTime: 'Tempo Médio de Resposta',
    completionRate: 'Taxa de Conclusão',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Estatísticas do Exercício',
    overview: 'Visão Geral',
    byCategory: 'Por Categoria',
    byNation: 'Por Nação',
    byDay: 'Por Dia',
    totalPatientsMoved: 'Total de Pacientes Transferidos',
    totalRequestsProcessed: 'Total de Pedidos Processados',
    averageProcessingTime: 'Tempo Médio de Processamento',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagrama de Fluxo',
    sankey: 'Sankey',
    nodeGraph: 'Grafo de Nós',
    refresh: 'Atualizar',
    noData: 'Sem dados de fluxo disponíveis',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Sobre',
    version: 'Versão',
    systemInfo: 'Informação do Sistema',
    buildDate: 'Data de Compilação',
    environment: 'Ambiente',
    description: 'ARCOS — Sistema Avançado de Comunicação de Pedidos',
    subtitle: 'Assistência a Baixas e Operações Médicas',
    whatIsArcos: 'O que é ARCOS? – Explicação para os participantes do exercício',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Facilitado pelo MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – onde a curiosidade encontra a colaboração.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Documentação',
    gettingStarted: 'Introdução',
    userGuide: 'Guia do Utilizador',
    faq: 'Perguntas Frequentes',
    troubleshooting: 'Resolução de Problemas',
    apiReference: 'Referência API',
    downloadTemplate: 'Transferir Modelo',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Importação de Pacientes',
    uploadFile: 'Carregar Ficheiro',
    selectFile: 'Selecionar Ficheiro',
    preview: 'Pré-visualização',
    importNow: 'Importar Agora',
    importing: 'A importar...',
    importSuccess: '{{count}} pacientes importados com sucesso',
    importFailed: 'Importação falhada',
    downloadTemplate: 'Transferir Modelo',
    dragDrop: 'Arraste e largue um ficheiro aqui, ou clique para selecionar',
    supportedFormats: 'Formatos suportados: XLSX, XLS, CSV',
    rowsFound: '{{count}} linhas encontradas',
    validRows: '{{count}} linhas válidas',
    invalidRows: '{{count}} linhas inválidas',
    duplicateRows: '{{count}} linhas duplicadas',
    previewData: 'Pré-visualizar Dados',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Planeamento de Transportes',
    planRoute: 'Planear Rota',
    routeBuilder: 'Construtor de Rotas',
    addWaypoint: 'Adicionar Ponto Intermédio',
    removeWaypoint: 'Remover Ponto Intermédio',
    estimatedDuration: 'Duração Estimada',
    distance: 'Distância',
    selectVehicle: 'Selecionar Veículo',
  },

  transportBooking: {
    title: 'Reserva de Transporte',
    bookTransport: 'Reservar Transporte',
    availableSlots: 'Vagas Disponíveis',
    bookingConfirmed: 'Reserva Confirmada',
    cancelBooking: 'Cancelar Reserva',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Planeamento de Capacidade',
    totalCapacity: 'Capacidade Total',
    usedCapacity: 'Capacidade Utilizada',
    availableCapacity: 'Capacidade Disponível',
    utilizationRate: 'Taxa de Utilização',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Modelos de Meios',
    dayTemplates: 'Modelos de Dia',
    createTemplate: 'Criar Modelo',
    editTemplate: 'Editar Modelo',
    deleteTemplate: 'Eliminar Modelo',
    templateName: 'Nome do Modelo',
    applyTemplate: 'Aplicar Modelo',
    noTemplates: 'Nenhum modelo encontrado',
    confirmDelete: 'Tem a certeza de que pretende eliminar este modelo?',
    confirmApply: 'Tem a certeza de que pretende aplicar este modelo? Isto substituirá os dados existentes.',
    exportTemplates: 'Exportar Modelos',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Barra de Anúncios',
    createAnnouncement: 'Criar Anúncio',
    editAnnouncement: 'Editar Anúncio',
    deleteAnnouncement: 'Eliminar Anúncio',
    message: 'Mensagem',
    startTime: 'Hora de Início',
    endTime: 'Hora de Fim',
    active: 'Ativo',
    noAnnouncements: 'Sem anúncios',
    confirmDelete: 'Tem a certeza de que pretende eliminar este anúncio?',
  },

  // ============================================================
  // COMPONENTS — Cadeias de componentes reutilizáveis
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Pesquisar...',
      noResults: 'Nenhum resultado encontrado',
      showing: 'A mostrar {{from}} a {{to}} de {{total}}',
      rowsPerPage: 'Linhas por página',
      previousPage: 'Página anterior',
      nextPage: 'Página seguinte',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Alterações Não Guardadas',
      message: 'Tem alterações por guardar. Tem a certeza de que pretende sair desta página?',
      stay: 'Permanecer na Página',
      leave: 'Sair da Página',
    },
    // EmptyState
    emptyState: {
      noData: 'Sem dados disponíveis',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Algo correu mal',
      message: 'Ocorreu um erro inesperado. Por favor, tente atualizar a página.',
      retry: 'Tentar Novamente',
    },
    // ExportButton
    exportButton: {
      export: 'Exportar',
      exporting: 'A exportar...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Imprimir',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Rascunho',
      review: 'Revisão',
      published: 'Publicado',
      selection: 'Seleção',
      inTransit: 'Em Trânsito',
      completed: 'Concluído',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Instância Online',
      message: 'Modo apenas leitura. Os dados são sincronizados a partir do servidor primário.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Está a visualizar como',
      loggedInAs: 'sessão iniciada como {{nation}}',
      returnTo: 'Voltar a {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Pesquisar páginas, pedidos, transportes...',
      searching: 'A pesquisar...',
      noResults: 'Sem resultados para "{{query}}"',
      navigate: 'Navegar',
      select: 'Selecionar',
      close: 'Fechar',
      pages: {
        dashboard: 'Painel',
        requests: 'Pedidos',
        transports: 'Transportes',
        map: 'Mapa',
        myPatients: 'Os Meus Pacientes',
        flowDiagram: 'Diagrama de Fluxo',
        statistics: 'Estatísticas',
        assets: 'Meios',
        startPoints: 'Pontos de Partida / Hubs',
        treatmentFacilities: 'Instalações de Tratamento',
        users: 'Utilizadores',
        settings: 'Definições',
        auditLogs: 'Registos de Auditoria',
        exerciseControl: 'Controlo do Exercício',
        dataSync: 'Sincronização de Dados',
        patientImport: 'Importação de Pacientes',
        notifications: 'Notificações',
        documentation: 'Documentação',
      },
      actions: {
        importPatientsJson: 'Importar Pacientes (JSON)',
        importPatientsExcel: 'Importar Pacientes (Excel)',
        importUsers: 'Importar Utilizadores (Excel)',
        importAssetTemplates: 'Importar Modelos de Ativos (Excel)',
        importDayTemplates: 'Importar Entradas de Modelo Diário (Excel)',
        exportRequests: 'Exportar Pedidos (Excel)',
        exportPatients: 'Exportar Pacientes (Excel)',
        exportUsers: 'Exportar Utilizadores (Excel)',
        exportCredentials: 'Exportar Credenciais (PDF)',
        exportAuditExcel: 'Exportar Registos de auditoria (Excel)',
        exportAuditPdf: 'Exportar Registos de auditoria (PDF)',
        pagePatientImport: 'Página de importação de pacientes',
        pageRequestDetail: 'Página de detalhe do pedido',
        pageUsers: 'Página de gestão de utilizadores',
        pageAssetTemplates: 'Página de modelos de ativos',
        pageDayTemplates: 'Página de modelos diários',
        pageRequests: 'Página de lista de pedidos',
        pageAuditLogs: 'Página de registos de auditoria',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sessão a Expirar',
      message: 'A sua sessão expira em <strong>{{time}}</strong>. Por favor, guarde o seu trabalho e inicie sessão novamente para continuar.',
      dismiss: 'Dispensar',
      logoutNow: 'Terminar Sessão Agora',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Selecione 4 fusos horários',
      configure: 'Configurar fusos horários',
      reset: 'Repor',
      apply: 'Aplicar',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Escolher Localização',
      latitude: 'Latitude',
      longitude: 'Longitude',
      clickToSelect: 'Clique no mapa para selecionar uma localização',
    },
    // Modal
    modal: {
      close: 'Fechar',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Início',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Manutenção do Sistema',
    message: 'O sistema está a ser reposto para o próximo dia de exercício. Por favor, aguarde até que o processo esteja concluído.',
    autoRefresh: 'Esta página será atualizada automaticamente quando o sistema estiver novamente disponível.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Pelo menos 10 caracteres',
    uppercase: '1 letra maiúscula',
    lowercase: '1 letra minúscula',
    digit: '1 dígito',
    special: '1 caractere especial',
  },
};

export default pt;
